export const HOUSE_AMBIENT_MAX_SPEED_PX_PER_SECOND = 46;

const MIN_AMBIENT_MOVE_MS = 1400;
const MAX_AMBIENT_MOVE_MS = 5600;

export function ambientMoveDurationMs(distancePx: number): number {
  const normalizedDistance = Math.max(0, distancePx);
  const duration = (normalizedDistance / HOUSE_AMBIENT_MAX_SPEED_PX_PER_SECOND) * 1000;
  return Math.ceil(Math.max(MIN_AMBIENT_MOVE_MS, Math.min(MAX_AMBIENT_MOVE_MS, duration)));
}

export function pointDistance(ax: number, ay: number, bx: number, by: number): number {
  return Math.hypot(bx - ax, by - ay);
}
